import {AxiosError} from 'axios';
import {POST_CHECK_ELIGIBILITY_APPEAL_REGISTRATION} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Error {
  message: string;
  code: string;
}

export interface CheckEligibilityResponse {
  eligible: boolean;
  error: Error | null;
}

export interface CheckEligibilityRequest {
  uuid: string;
  userType: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: CheckEligibilityResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAppealRegistrationCheckEligibility = ({onSuccess, onError}: Input = {}) => {
  const postAppealRegistrationCheckEligibility = async (requestBody: CheckEligibilityRequest) => {
    const res = await axiosClient.post<CheckEligibilityResponse>(
        POST_CHECK_ELIGIBILITY_APPEAL_REGISTRATION,
        requestBody
    );

    return res.data;
  };

  return useCustomMutation(postAppealRegistrationCheckEligibility, {
    onSuccess,
    onError,
  });
};
